import { PropsWithChildren } from 'react'
import { createTheme, responsiveFontSizes, ThemeProvider as MuiThemeProvider } from '@mui/material'
import { deepmerge } from '@mui/utils'

import { useCompany } from 'utils/company'

import { useDefaultTheme } from './useDefaultTheme'

export default function ThemeProvider({ children }: PropsWithChildren): JSX.Element {
  const { data: company } = useCompany()

  const theme = responsiveFontSizes(createTheme(deepmerge(useDefaultTheme(), company?.theme)), {
    factor: 2.5,
  })

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
}
